<template>
  <div class="topNavbar top_nav navbar-fixed-top">
    <div class="nav_menu">
      <nav>
        <div class="topNavbar__title">{{ manager.teamName }}</div>
        <ul class="nav navbar-nav navbar-right">
          <DropdownManagerInfo
            :name="manager.name"
            :position="manager.position"
            :permissionUserBehavior="permissionUserBehavior"
            :permissionPositionManagement="permissionPositionManagement"
            :permissionUserManagement="permissionUserManagement"
            @logout="logout"
          ></DropdownManagerInfo>
          <DropdownStored
            :permissionStore="permissionStore"
            v-if="hasStoredPermission"
          ></DropdownStored>
          <DropdownMobilePay
            :permissionMobilePayment="permissionMobilePayment"
          ></DropdownMobilePay>
          <DropdownCustomerInfo
            :permissionStore="permissionStore"
            :permissionLandmark="permissionLandmark"
            :permissionCustomer="permissionCustomer"
          ></DropdownCustomerInfo>
          <DropdownReservation
            :permissionReservation="permissionReservation"
          ></DropdownReservation>
          <DropdownTransaction
            :permissionTransactionStatistics="permissionTransactionStatistics"
            :permissionTransaction="permissionTransaction"
          ></DropdownTransaction>
          <DropdownLongTermCare
            v-if="hasLongTermCarePermission"
          ></DropdownLongTermCare>
          <DropdownDriverInfo
            :permissionDriverMonitor="permissionDriverMonitor"
            :permissionDriverTrajectory="permissionDriverTrajectory"
          ></DropdownDriverInfo>
          <!-- @refresh="refresh" -->
          <DropdownPhoneHail
            :permissionCallCar="permissionCallCar"
            :permissionInstanceTransactionRecord="
              permissionInstanceTransactionRecord
            "
            :permissionHailBillPage="permissionHailBillPage"
            :permissionScheduledArea="permissionScheduledArea"
            :permissionScheduledBoard="permissionScheduledBoard"
            :permissionDispatchArea="permissionDispatchArea"
            v-if="hasPhoneHailPermission"
          ></DropdownPhoneHail>
          <!-- @refresh="refresh" -->
          <DropdownMessages
            :permissionDriverMessage="permissionDriverMessage"
            :permissionAnnouncement="permissionAnnouncement"
          ></DropdownMessages>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import DropdownCustomerInfo from '@/components/dropDown/DropdownCustomerInfo'
import DropdownDriverInfo from '@/components/dropDown/DropdownDriverInfo'
import DropdownManagerInfo from '@/components/dropDown/DropdownManagerInfo'
import DropdownMobilePay from '@/components/dropDown/DropdownMobilePay'
import DropdownReservation from '@/components/dropDown/DropdownReservation'
import DropdownTransaction from '@/components/dropDown/DropdownTransaction'
import DropdownLongTermCare from '@/components/dropDown/DropdownLongTermCare'
import DropdownPhoneHail from '@/components/dropDown/DropdownPhoneHail'
import DropdownMessages from '@/components/dropDown/DropdownMessages'
import DropdownStored from '@/components/dropDown/DropdownStored'
import { cookies, logoutCookies } from '@/utils/cookies'
import { getAdminAuthorization } from '../assets/js/tool/adminAuth'
import { hasTeamRole } from '@/utils/teamRoleAuth'

export default {
  data() {
    return {
      manager: {
        name: '',
        teamName: '',
        permission: null,
        position: '',
      },
    }
  },
  methods: {
    logout() {
      logoutCookies()
      this.$router.push({ name: 'Login' })
    },
    refresh() {
      this.$router.go(0)
    },
  },
  components: {
    DropdownCustomerInfo,
    DropdownDriverInfo,
    DropdownManagerInfo,
    DropdownMessages,
    DropdownMobilePay,
    DropdownReservation,
    DropdownTransaction,
    DropdownLongTermCare,
    DropdownPhoneHail,
    DropdownStored,
  },
  mounted() {
    this.manager.name = cookies.get('GladName')
    this.manager.permission = cookies.get('GladPermission')
    this.manager.teamName = cookies.get('GladTeamName')
    this.manager.position = cookies.get('GladPosition')
    this.manager.teamCodeCookie = cookies.get('GladTeamCode')
  },
  computed: {
    permissionDriverMonitor() {
      return getAdminAuthorization('driverMonitor') >= 1
    },
    permissionDriverTrajectory() {
      return getAdminAuthorization('driverTrajectory') >= 1
    },
    permissionDriverMessage() {
      return getAdminAuthorization('driverMessage') >= 1
    },
    permissionCallCar() {
      return getAdminAuthorization('callCar') >= 1
    },
    permissionInstanceTransactionRecord() {
      return getAdminAuthorization('instanceTransactionRecord') >= 1
    },
    permissionHailBillPage() {
      return getAdminAuthorization('saveHailBill') >= 1
    },
    permissionReservation() {
      return getAdminAuthorization('reservation') >= 1
    },
    permissionUserBehavior() {
      // 使用者行為 禁止/查閱
      return getAdminAuthorization('userBehavior') >= 1
    },
    permissionPositionManagement() {
      return getAdminAuthorization('positionManagement') >= 1
    },
    permissionUserManagement() {
      return getAdminAuthorization('userManagement') >= 1
    },
    permissionLandmark() {
      return getAdminAuthorization('landmark') >= 1
    },
    permissionStore() {
      return getAdminAuthorization('store') >= 1
    },
    permissionCustomer() {
      return getAdminAuthorization('customer') >= 1
    },
    permissionScheduledArea() {
      return getAdminAuthorization('scheduledArea') >= 1
    },
    permissionScheduledBoard() {
      return getAdminAuthorization('scheduledBoard') >= 1
    },
    permissionDispatchArea() {
      return getAdminAuthorization('dispatchArea') >= 1
    },
    permissionTransactionStatistics() {
      return getAdminAuthorization('transactionStatistics') >= 1
    },
    permissionTransaction() {
      return getAdminAuthorization('transaction') >= 1
    },
    permissionMobilePayment() {
      return getAdminAuthorization('mobilePayment') >= 1
    },
    permissionAnnouncement() {
      return getAdminAuthorization('announcement') >= 1
    },
    // 使用 teamRoles 權限檢查
    hasLongTermCarePermission() {
      return hasTeamRole('long_term_care')
    },
    hasPhoneHailPermission() {
      return hasTeamRole('dispatch_schedule')
    },
    hasStoredPermission() {
      return hasTeamRole('stored_value')
    },
  },
}
</script>

<style lang="scss" scoped>
.topNavbar {
  position: sticky;
  height: 58px;

  &__title {
    display: inline-block;
    margin: 13px 20px 12px 20px;
    font-size: 20px;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopNavbar.vue